export default __webpack_public_path__ + "images/f6b83f57c688256e68fbd799178fcaf3-do_3.png";